import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/specials/components/SpecialsPageContent.tsx");
